<template>
    <div class="card-curvey">
        <slot name = "title">
          <h3>Unknown Terms</h3>
        </slot>
        <v-data-table
                :headers="headers"
                :items="unknownTerms"
                items-per-page="20"
        >
            <template v-slot:items="props">
                <td>{{ props.item.keyword }}</td>
                <td class="text-xs-center">{{ props.item.times }}</td>
                <td class="justify-center layout px-0">
                    <v-btn
                            small
                            round
                            class="mr-2 white--text"
                            @click="trainTerm(props.item.keyword)"
                            color="red"
                    >
                        Delete
                    </v-btn>
                </td>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import common from "../../utils/common";

    export default {
        name: "unknown-words",
        data () {
          return {
              unknownTerms: [],
              headers: [
                  {
                      text: 'keyword',
                      align: 'left',
                      sortable: false,
                      value: 'keyword'
                  },
                  {
                      text: 'times',
                      align: 'center',
                      sortable: false,
                      value: 'times'
                  },
                  {
                      text: 'Train',
                      align: 'right',
                      sortable: false,
                      value: 'train'
                  },

                  // { text: 'Actions', value: 'name', sortable: false, align: 'center', }
              ],
          }
        },
        mounted() {
            this.getUnknownTerms()
        },
        methods: {
            getUnknownTerms () {
                this.$http_bot.get('analytics/unknown_terms')
                .then(response=> {
                    this.unknownTerms = response.data
                })
                .catch(error=>{
                    this.$store.dispatch('setLoader',false)
                    if (error.response && error.response.status === 401) {
                        common.logOut()
                    } else {
                        this.$store.dispatch('setErrorMessage', true)
                    }
                })
            },
            trainTerm (term) {
                this.$http_bot.post(`analytics/`,{
                    term: term
                })
                .then(response=>{
                    let index = this.unknownTerms.findIndex(item=>{
                        return term === item.keyword
                    })
                    this.unknownTerms.splice(index,1)
                })
                .catch(error=>{
                    this.$store.dispatch('setLoader',false)
                    if (error.response && error.response.status === 401) {
                        common.logOut()
                    } else {
                        this.$store.dispatch('setErrorMessage', true)
                    }
                })

            }
        }
    }
</script>

<style >
    .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border-color: transparent !important;
    }
</style>
